import { useAlert } from "matsuri-ui"
import { useEffect } from "react"
import { copyToClipboard } from "./copyToClipboard"

const genSuccessMessageForClipboardCopy = (label?: string) =>
    label ? `${label}をコピーしました!` : "コピーしました!"

const genFailureMessageForClipboardCopy = (label?: string) =>
    label ? `${label}コピーに失敗しました` : "コピーに失敗しました"

export const useCopyToClipboard = ({
    text,
    label,
    key
}: {
    text: string
    label?: string
    key: string
}) => {
    const { addAlert } = useAlert()
    useEffect(() => {
        const handler = (event: KeyboardEvent) => {
            if (text && (event.ctrlKey || event.metaKey) && event.key === key) {
                const success = copyToClipboard(text)
                if (success) {
                    addAlert(genSuccessMessageForClipboardCopy(label), {
                        severity: "success",
                        duration: 3500
                    })
                } else {
                    addAlert(genFailureMessageForClipboardCopy(label), {
                        severity: "error"
                    })
                }
            }
        }
        window.addEventListener("keydown", handler)
        return () => {
            window.removeEventListener("keydown", handler)
        }
    }, [addAlert, label, text, key])
}
